export default __webpack_public_path__ + "static/media/PCB.fd57fca1.png";